module.exports = __webpack_public_path__ + "img/cover.4baf5329.svg";